export function init() {
   setupSwipableContainers();
}

function setupSwipableContainers() {
    document.querySelectorAll('.js-horizontal-scroll-container').forEach(container => {
        const scrollEl = container.querySelector('.js-horizontal-scroll'),
            nextNavEl = container.querySelector('.js-scroll-to-next'),
            prevNavEl = container.querySelector('.js-scroll-to-prev');

        // Next nav
        nextNavEl.addEventListener('click', e => {
            smoothScrollToElement(scrollEl, 'next');
        });
        
        // Prev nav
        prevNavEl.addEventListener('click', e => {
            smoothScrollToElement(scrollEl, 'prev');
        });
    });
}

function smoothScrollToElement(scrollEl, dir) {
    const slideDimensions = scrollEl.querySelector('li').getBoundingClientRect();
    
    let distance = slideDimensions.width;

    if (dir === 'next') {
        // If direction is next and last element is in view already, scroll back to start
        if (isInViewport(scrollEl.querySelector('li:last-child'), scrollEl)) {
            scrollEl.scrollTo({
                behavior: 'smooth',
                left: 0
            });

            return;
        }
    } else {
        // If direction is prev and first element is in view already, scroll to end
        if (isInViewport(scrollEl.querySelector('li:first-child'), scrollEl)) {
            distance = scrollEl.querySelectorAll('li').length * slideDimensions.width;

            scrollEl.scrollTo({
                behavior: 'smooth',
                left: distance
            });
            
            return;
        }
        
        distance = distance * -1;
    }

    scrollEl.scrollBy({
        behavior: 'smooth',
        left: distance
    });
}

function isInViewport(elem, containerEl) {
    let elBounding = elem.getBoundingClientRect(),
        containerBounding = containerEl.getBoundingClientRect();
    
    return (
        Math.round(elBounding.left) >= Math.round(containerBounding.left) &&
        Math.floor(elBounding.right) <= Math.round(containerBounding.right)
    );
}